export default class CanvasMapper {
    constructor(actor) {
        this.actor = actor;
    }
    getInputData() {
        return this.actor.getImage();
    }
    modified() {
        this.actor.modified();
    }
}
